import React from 'react';
import {
  string, shape, bool, arrayOf, func,
} from 'prop-types';
import { onCtaClick } from 'helpers/Utils';
import { Heading, Small, Button } from 'components/common';
import CompareElementColumn from 'components/product/CompareElementColumn';
import './ProductHeroPanel.scss';

const ProductHeroPanel = ({
  bgImageUrl,
  productName,
  image = {},
  ctaButton = {},
  comparables = [],
  updatedAtText,
  setCtaRef,
  onCtaLinkClick,
  imageOrientation,
}) => (
  <div
    className="product-hero-panel"
    style={{
      backgroundImage: `url(${bgImageUrl})`,
    }}
    data-selector-type="product-hero-panel"
  >
    <div className="content-container-wrapper">
      <div className="content-row-wrapper">
        <div className="content-column-wrapper">
          <div className={`product-image ${imageOrientation === 'LANDSCAPE' ? 'product-image-landscape' : 'product-image-portrait'}`}>
            {image && (
              <img src={image.url} alt={image.alt} data-selector-type="product-hero-panel-image" />
            )}
          </div>
          {productName && (
            <div className="product-name" data-selector-type="product-hero-panel-product-name">
              <Heading as="h1" styleAs="h3">
                {productName}
              </Heading>
            </div>
          )}
          {updatedAtText && (
            <div className="product-updated-at" data-selector-type="product-hero-panel-product-updated-at">
              <Small secondary>
                {updatedAtText}
              </Small>
            </div>
          )}
          {comparables && comparables.length > 0 && (
            <div className="compare-elements">
              {comparables.map(element => (
                <CompareElementColumn
                  {...element}
                  key={element.id}
                />
              ))}
            </div>
          )}
          {ctaButton && ctaButton.show && (
            <div className="cta-button" ref={(r) => { if (setCtaRef) { setCtaRef(r); } }}>
              <Button
                className="cta-btn-apply"
                primary
                onClick={onCtaClick(ctaButton, onCtaLinkClick)}
              >
                {ctaButton.label}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

ProductHeroPanel.defaultProps = {
  comparables: [],
  bgImageUrl: null,
  setCtaRef: null,
  updatedAtText: '',
  onCtaLinkClick: null,
  ctaButton: null,
  imageOrientation: 'LANDSCAPE',
};

ProductHeroPanel.propTypes = {
  bgImageUrl: string,
  productName: string.isRequired,
  image: shape({
    url: string.isRequired,
    alt: string,
  }).isRequired,
  ctaButton: shape({
    show: bool,
    label: string.isRequired,
    link: shape({
      url: string.isRequired,
    }),
  }),
  comparables: arrayOf(shape({
    id: string.isRequired,
    displayValue: string.isRequired,
    title: shape({}),
    description: string,
    tooltip: string,
    prefix: string,
    suffix: string,
  })),
  setCtaRef: func,
  updatedAtText: string,
  onCtaLinkClick: func,
  imageOrientation: string,
};

export default ProductHeroPanel;
